import { render, staticRenderFns } from "./Cont.vue?vue&type=template&id=fced4a12&scoped=true&"
import script from "./Cont.vue?vue&type=script&lang=js&"
export * from "./Cont.vue?vue&type=script&lang=js&"
import style0 from "./Cont.vue?vue&type=style&index=0&id=fced4a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced4a12",
  null
  
)

export default component.exports